import React, { useEffect, useState } from "react";
import axios from "axios";
import { baseUrl } from "../constant.js";
const Paindingtrade = ({
  name,
  expary,
  ordertimrdate,
  bidtype,
  holdingmargin,
  marginused,
  bid,
  lot,
  orderid,
  closeordertype,
  status,
  ordertype1,
}) => {
  const [type, setType] = useState("1");
  const [btnStatus, setBtnStatus] = useState(status);
  const [cancleorder, setcancleorder] = useState("Cancel Order");
  const [close, setClose] = useState("");

  console.log(ordertype1);

  const ordertype = async () => {
    if (orderid) {
      const token = localStorage.getItem("token");
      const formdata = new FormData();
      formdata.append("Token", token);
      formdata.append("orderID", orderid);
      formdata.append("type", type);
      const result = await axios.post(
        baseUrl + `authController/closeCancelTrade`,
        formdata,
      );
      setcancleorder("Cancelled");
      setBtnStatus(4);
    } else {
      return (
        <>
          <div>
            <h3 style={{ color: "white" }}>No data found</h3>
          </div>
        </>
      );
    }
  };
  useEffect(() => {
    if (ordertype1 == 1) {
      setClose("Market");
    }
    if (ordertype1 == 2) {
      setClose("Order");
    } else if (ordertype1 == 3) {
      setClose("SL");
    } else if (ordertype1 == 4) {
      setClose("Admin");
    } else if (ordertype1 == 5) {
      setClose("Carried Forward");
    } else if (ordertype1 == 6) {
      setClose("Month Settlement");
    }
  });

  return (
    <>
      <div className="futures_List">
        <div className="trades_List_text">
          <div className="traders_button" style={{ marginBottom: "7px 0px" }}>
            {bidtype == 1 && (
              <span
                style={{
                  border: "1px solid #4bad00",
                  marginRight: "6px",
                  padding: "2px 10px",
                  color: "#4bad00",
                  borderRadius: "5px",
                  fontSize: "10px",
                }}
              >
                BuyX{lot}
              </span>
            )}
            {bidtype == 2 && (
              <span
                style={{
                  border: "1px solid red",
                  marginRight: "6px",
                  padding: "2px 10px",
                  color: "red",
                  borderRadius: "5px",
                  fontSize: "10px",
                }}
              >
                SellX{lot}
              </span>
            )}
            <span
              style={{
                border: "1px solid #ed0017",
                marginRight: "6px",
                padding: "2px 10px",
                color: "#ed0017",
                borderRadius: "5px",
                fontSize: "10px",
              }}
            >
              {close}
            </span>
          </div>
          <h3>
            {name}_{expary}
          </h3>
          {bidtype == 1 && <h5>Bought by Trader</h5>}
          {bidtype == 2 && <h5>Sold by Trader </h5>}
          <p>{ordertimrdate} </p>
        </div>
        <div className="trades_List_text text-right">
          {bidtype == 1 && (
            <div className="trades_amount_btn" style={{ marginBottom: "0px" }}>
              <span
                className="trdes_span"
                style={{
                  border: "1px solid green",
                  padding: "2px 10px",
                  color: "green",
                  borderRadius: "5px",
                  fontSize: "10px",
                  background: "transparent",
                }}
              >
                {bid}
              </span>
            </div>
          )}
          {bidtype == 2 && (
            <div className="trades_amount_btn" style={{ marginBottom: "0px" }}>
              <span
                className="trdes_span"
                style={{
                  border: "1px solid red",
                  padding: "2px 10px",
                  color: "red",
                  borderRadius: "5px",
                  fontSize: "10px",
                  background: "transparent",
                }}
              >
                {bid}
              </span>
            </div>
          )}
          {btnStatus == 4 && (
            <div className="traders_button" style={{ marginBottom: "7px" }}>
              <button
                type="button"
                style={{
                  border: "1px solid #ed0017",
                  padding: "2px 10px",
                  color: "#fff",
                  borderRadius: "5px",
                  fontSize: "10px",
                  background: "#ed0017",
                }}
              >
                Cancelled
              </button>
            </div>
          )}
          {btnStatus == 1 && (
            <div
              className="traders_button"
              onClick={() => ordertype()}
              style={{ marginBottom: "7px" }}
            >
              <button
                type="button"
                style={{
                  border: "1px solid #ed0017",
                  padding: "2px 10px",
                  color: "rgb(255, 255, 255)",
                  borderRadius: "5px",
                  fontSize: "10px",
                  background: "#ed0017",
                }}
              >
                {cancleorder}
              </button>
            </div>
          )}
          <h5>Marginused :{marginused} </h5>
          <h5>Holding Mar.Req:{holdingmargin}</h5>
        </div>
      </div>
    </>
  );
};

export default Paindingtrade;
